import { zxcvbnOptions } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';

import en from './en';
import enUK from './en-UK';
import esES from './es-ES';
import deDE from './de-DE';
import ukUA from './uk-UA';
import ja from './ja';
import ko from './ko';
import th from './th';
import vi from './vi';
import id from './id';
import zhCN from './zh-CN';
import zhHK from './zh-HK';
import zhTW from './zh-TW';

const locales = {
    en: en,
    ['en-UK']: enUK,
    ['es-ES']: esES,
    ['de-DE']: deDE,
    ['uk-UA']: ukUA,
    ja: ja,
    ko: ko,
    th: th,
    vi: vi,
    id: id,
    ['zh-CN']: zhCN,
    ['zh-HK']: zhHK,
    ['zh-TW']: zhTW,
};
export const configureZxcvbn = (locale) => {
    const options = {
        translations: locales[locale],
        graphs: zxcvbnCommonPackage.adjacencyGraphs,
        dictionary: {
            ...zxcvbnCommonPackage.dictionary,
            ...zxcvbnEnPackage.dictionary,
        },
    };
    zxcvbnOptions.setOptions(options);
};
